import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {
  provideClientHydration,
  TransferState,
} from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SharedModule } from './components/shared.module';
import { isYusafirDomain } from './utils/domain-routes';

export function getRoutes(): Routes {
  const isYusafir = isYusafirDomain();

  return [
    // {
    //   path: '',
    //   loadChildren: () => import('./pages/page.module').then(m => m.PagesModule)
    // }
    // {
    //   path: '',
    //   loadChildren: () =>
    //     import('./pages/home/home.module').then((m) => m.HomeModule),
    // },
    {
      path: '',
      loadChildren: () =>
        isYusafir
          ? import('./pages/yusafir-home/yusafir-home.module').then(
              (m) => m.YusafirHomeModule
            )
          : import('./pages/home/home.module').then((m) => m.HomeModule),
    },
    {
      path: 'search-results',
      loadChildren: () =>
        import('./pages/search-results/search-results.module').then(
          (m) => m.SearchResultsModule
        ),
    },
    {
      path: 'product',
      loadChildren: () =>
        import('./pages/product/product.module').then((m) => m.ProductModule),
    },
    // {
    //   path: 'ondc-product',
    //   loadChildren: () => import('./pages/ondc/ondc.module').then((m) => m.OndcModule),
    // },
    {
      path: 'purchase-success',
      loadChildren: () =>
        import('./pages/purchase-success/purchase.module').then(
          (m) => m.PurchaseSuccessModule
        ),
    },
    {
      path: 'terms-and-condition',
      loadChildren: () =>
        import('./pages/terms-and-condition/terms-and-condition.module').then(
          (m) => m.TermsAndConditionModule
        ),
    },
    {
      path: 'privacy-policy',
      loadChildren: () =>
        import('./pages/privacy-policy/privacy-policy.module').then(
          (m) => m.PrivacyPolicyModule
        ),
    },
    {
      path: 'cancellation-and-refund-policy',
      loadChildren: () =>
        import(
          './pages/cancellation-and-refund-policy/cancellation-and-refund-policy.module'
        ).then((m) => m.CancellationAndRefundPolicyModule),
    },
    {
      path: 'disclaimer',
      loadChildren: () =>
        import('./pages/disclaimer/disclaimer.module').then(
          (m) => m.DisclaimerModule
        ),
    },
    {
      path: 'contact-us',
      loadChildren: () =>
        import('./pages/contact-us/contact-us.module').then(
          (m) => m.ContactUsModule
        ),
    },
    {
      path: 'profile',
      loadChildren: () =>
        import('./pages/profile/profile.module').then((m) => m.ProfileModule),
    },
    {
      path: 'about-us',
      loadChildren: () =>
        import('./pages/about-us/about-us.module').then((m) => m.AboutUsModule),
    },
    {
      path: 'blog',
      loadChildren: () =>
        import('./pages/blog/blog.module').then((m) => m.BlogModule),
    },
    {
      path: 'payment',
      loadChildren: () =>
        import('./pages/payment/payment.module').then((m) => m.PaymentModule),
    },
    {
      path: 'payment-failed',
      loadChildren: () =>
        import('./pages/payment-failed/payment-failed.module').then(
          (m) => m.PaymentFailedModule
        ),
    },
    {
      path: 'transfer-payment',
      loadChildren: () =>
        import('./pages/transfer-payment/transfer-payment.module').then(
          (m) => m.TransferPaymentModule
        ),
    },
    {
      path: 'cart',
      loadChildren: () =>
        import('./pages/cart/cart.module').then((m) => m.CartModule),
    },
    {
      path: 'travel-agent',
      loadChildren: () =>
        import('./pages/travel-agent/travel-agent.module').then(
          (m) => m.TravelAgentModule
        ),
    },
    {
      path: 'billing-details',
      loadChildren: () =>
        import('./pages/billing-details/billing-details.module').then(
          (m) => m.BillingDetailsModule
        ),
    },
    {
      path: 'attraction-pass',
      loadChildren: () =>
        import('./pages/attraction-pass/attraction-pass.module').then(
          (m) => m.AttractionPassModule
        ),
    },
    {
      path: 'partners',
      loadChildren: () =>
        import('./pages/partners/partners.module').then(
          (m) => m.PartnersModule
        ),
    },
    {
      path: 'distributor',
      loadChildren: () =>
        import('./pages/distributor/distributor.module').then(
          (m) => m.DistributorModule
        ),
    },
    {
      path: 'dutyfree',
      loadChildren: () =>
        import('./pages/dummy-component/dummy-component.module').then(
          (m) => m.DummyModule
        ),
    },
    {
      path: 'robots.txt',
      loadChildren: () =>
        import('./pages/robots/robots.module').then((m) => m.RobotsModule),
    },
    {
      path: 'sitemap.xml',
      loadChildren: () =>
        import('./pages/sitemap/sitemap.module').then((m) => m.SitemapModule),
    },
    {
      path: 'disneyadventurecruise',
      loadChildren: () =>
        import('./pages/disney/disney.module').then((m) => m.DisneyModule),
    },
    {
      path: 'dubai-hype-guide',
      loadChildren: () =>
        import('./pages/dubai/dubai.module').then((m) => m.DubaiModule),
    },
    {
      path: ':id',
      loadChildren: () =>
        import('./pages/landing-page/landing-page.module').then(
          (m) => m.LandingPageModule
        ),
    },
    {
      path: 'home',
      redirectTo: '',
      pathMatch: 'full',
    },
    {
      path: '**',
      loadChildren: () =>
        import('./pages/notfound-page/notfound-page.module').then(
          (m) => m.NotfoundPageModule
        ),
    },
  ];
}

@NgModule({
  imports: [
    RouterModule.forRoot(getRoutes(), {
      useHash: environment.useHash,
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'top',
    }),
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
  ],
  exports: [RouterModule],
  providers: [provideClientHydration(), TransferState],
})
export class AppRoutingModule {}
